import WebpPicture from '~/components/WebpPicture.vue';
export default {
  name: 'report',
  props: ['rawComment'],
  components: {
    WebpPicture: WebpPicture
  },
  computed: {
    comment: function comment() {
      this.rawComment.date = new Date(this.rawComment.date);
      return this.rawComment;
    },
    now: function now() {
      return useTimeStore().now;
    },
    ago: function ago() {
      return this.$timeformat.ago(this.comment.date, this.now);
    }
  }
};